// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SecretChatMessagesEmpty__container-b9bc96 {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  background-color: var(--base-0);
}

.SecretChatMessagesEmpty__info-block-f8a369 {
  --info-block-text-color: var(--addition-50);
  background: var(--average-background);
}

.SecretChatMessagesEmpty__icon-f72d73 {
  margin-inline-end: 8px;
  fill: currentColor;
  min-width: 16px;
}

.SecretChatMessagesEmpty__description-container-d33a10 {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: start;
  margin-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/MessagesEmpty/SecretChatMessagesEmpty/SecretChatMessagesEmpty.styles.m.css"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;AACF;;AAEA;EACE,2CAAA;EACA,qCAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AACF","sourcesContent":[".container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  overflow: hidden;\n  background-color: var(--base-0);\n}\n\n.info-block {\n  --info-block-text-color: var(--addition-50);\n  background: var(--average-background);\n}\n\n.icon {\n  margin-inline-end: 8px;\n  fill: currentColor;\n  min-width: 16px;\n}\n\n.description-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  text-align: start;\n  margin-bottom: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SecretChatMessagesEmpty__container-b9bc96`,
	"info-block": `SecretChatMessagesEmpty__info-block-f8a369`,
	"infoBlock": `SecretChatMessagesEmpty__info-block-f8a369`,
	"icon": `SecretChatMessagesEmpty__icon-f72d73`,
	"description-container": `SecretChatMessagesEmpty__description-container-d33a10`,
	"descriptionContainer": `SecretChatMessagesEmpty__description-container-d33a10`
};
module.exports = ___CSS_LOADER_EXPORT___;
